<template>
  <div class="md-layout card-relatorio">
    <toolbar
      v-if="form.id != null && form.id != undefined"
      :item="form"
      grafico="1"
      :onGrafico="onGrafico"
    ></toolbar>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>{{icone_title}}</md-icon>
          </div>
          <h4 class="title" v-html="title"></h4>
        </md-card-header>

        <md-card-content>
          <slot name="body">
            <div v-if="loading" class="md-layout">
              <div class="md-layout-item md-size-100 box-carregando">
                <md-progress-spinner
                  :md-diameter="40"
                  :md-stroke="4"
                  md-mode="indeterminate"
                >{{msg_status}}</md-progress-spinner>
              </div>
            </div>

            <div class="md-layout">
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">ID</label>
                <div class="md-form-text">{{form.id}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Cliente / Empresa</label>
                <div class="md-form-text">{{form.nome_cliente}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Responsável Controlare</label>
                <div class="md-form-text">{{form.nome_responsavel}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Check List</label>
                <div class="md-form-text">{{form.nome_checklist}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Data da Auditoria</label>
                <div class="md-form-text">{{form.data | date_show}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Unidade</label>
                <div class="md-form-text">{{form.nome_estabelecimento}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Responsável Local</label>
                <div class="md-form-text">{{form.responsavel_local}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Auditoria acompanhada por</label>
                <div class="md-form-text">{{form.audit}}</div>
              </div>
            </div>
          </slot>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100 text-center mb-20">
      <h3 class="title">
        Nota Geral:
        <span
          v-bind:style="getStyleNotaTotal(form.nota_final)"
        >{{form.nota_final | nota_final_show}}</span>
      </h3>
    </div>

    <div
      class="md-layout-item md-size-100"
      v-if="form.categorias != null && form.categorias != undefined"
    >
      <md-card v-for="(item,index) in form.categorias" :key="index">
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <slot name="header">
              <h4 class="title">{{item.nome}}</h4>
            </slot>
          </div>
        </md-card-header>
        <md-card-content>
          <slot name="body">
            <div class="list-custom">
              <!-- Item -->
              <div
                class="md-layout list-item"
                v-for="(sub_item, sub_index) in item.itens"
                :key="sub_item.id"
              >
                <div
                  class="md-layout-item md-size-5 md-small-size-10 md-xsmall-size-100 text-center"
                >
                  <h6>{{sub_index+1}}</h6>
                </div>
                <div class="md-layout-item md-size-85 md-small-size-75 md-xsmall-size-100 content">
                  <p>{{sub_item.nome}}</p>
                  <p v-if="sub_item.parecer != null && sub_item.parecer.length > 1">
                    <strong>Observações:</strong>
                    {{sub_item.parecer}}
                  </p>
                  <div
                    class="group-img"
                    v-if="sub_item.arquivos != null && sub_item.arquivos.length > 0 "
                  >
                    <h6>Imagens</h6>
                    <show_image :arquivos="sub_item.arquivos" :caption="sub_item.nome"></show_image>
                    <!--<a href="#!" class="item-img" v-for="arquivo in sub_item.arquivos" :key="arquivo.id">
                      <img class="img-responsive" v-bind:src="arquivo.url_thumb" alt="Imagem">
                    </a>-->
                  </div>
                </div>
                <div
                  class="md-layout-item md-size-10 md-small-size-15 md-xsmall-size-100 text-center"
                >
                  <h5 v-bind:class="getClassNota(sub_item.nota)">{{mostra_nota(sub_item.nota)}}</h5>
                </div>
              </div>

              <div class="md-layout list-item text-center" v-if="item.nota > -1">
                <h4 class="title-valor">
                  Avaliação:
                  <span
                    v-bind:class="getClassNota(item.nota)"
                  >{{item.nota | nota_final_show}}</span>
                </h4>
              </div>
            </div>
          </slot>
        </md-card-content>
      </md-card>

      <!-- Info -->
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>warning</md-icon>
          </div>
          <h4 class="title">Observações gerais</h4>
        </md-card-header>
        <md-card-content class="box-info">
          <slot name="body">
            <p>Texto para observações: Lorem ipsum dolor sit amet, consectetur adipiscing elit integer sodales fermentum purus ac dictum. Curabitur porta quis eros sed varius donec tempor, lacus ut molestie ultrices.</p>
            <h5>Legendas</h5>
            <p>
              <span>C:</span> Conforme com as normas vigentes da vigilância sanitária.
            </p>
            <p>
              <span class="low">N/C:</span> Não conforme com as normas vigentes da vigilância sanitária.
            </p>
            <p>
              <span>N/A:</span> Não aplicável.
            </p>
          </slot>
        </md-card-content>
      </md-card>
    </div>
    <modal v-if="form != null && show_grafico" @close="onCloseModal" class="md-size-75">
      <div slot="body">
        <grafico_inspecao v-bind:id="form.id"></grafico_inspecao>
      </div>
    </modal>
  </div>
</template>

<style scoped>
@import "../../../assets/css/validate.css";
@import "../../../assets/css/form_custom.css";
</style>
<script>
import service from "../../../services/InspecaoService";
import autocomplete from "../../../components/Rend/autocomplete";
import filelogo from "../../../components/Rend/filelogo";
import mixin_validator from "../../../library/mixin/validator";
import mixin_util from "../../../library/mixin/util";
import modal from "../../../components/Modal";
import Datepicker from "../../../components/Rend/vuejs-datepicker/src/components/Datepicker";
import ptBR from "../../../components/Rend/vuejs-datepicker/src/locale/translations/pt-BR";
import CardCadastro from "../../../components/CardCadastro";
import vue_select from "../../../components/Rend/vue-select/src/Select.vue";
import show_image from "../../../components/Rend/show-image/show.vue";
import toolbar from "../components/toolbar_visualizar.vue";
import swal from "sweetalert2";
import bargroup from "../../components/graficos/bargroup";
import grafico_inspecao from "./grafico_inspecao";

export default {
  components: {
    autocomplete,
    filelogo,
    modal,
    Datepicker,
    CardCadastro,
    vue_select,
    show_image,
    toolbar,
    bargroup,
    grafico_inspecao
  },

  mixins: [mixin_util, mixin_validator],
  props: ["id_load", "show_back_button", "onBack", "onSave"],
  data() {
    return {
      acao: "Cadastrar",
      form: {},
      perfis: [],
      clientes: [],
      clientes_list: [],
      show_perfil: false,
      file_upload: null,
      botao_voltar_visible: true,
      loading: true,
      result2: "",
      disableButton: false,
      show_message: "off",
      message_text: "",
      message_type: "success",
      interval_message: null,
      showDialogError: false,
      msg_status: "Carregando",
      show_modal_contacts: false,
      show_sub_form: true,
      data: null,
      data_cadastro: null,
      language_date: ptBR,
      title: "Relatório de auditoria técnica",
      icone_title: "assignment",

      show_grafico: false
    };
  },
  mounted() {
    let self = this;
    this.form = service.getModelVisualizar();
    this.configureMessages();

    if (this.show_back_button != null && this.show_back_button != undefined) {
      this.botao_voltar_visible = this.show_back_button;
    }

    this.disableButton = true;

    if (
      this.cliente_oculto != null &&
      this.cliente_oculto != undefined &&
      this.cliente_oculto.toString() == "1"
    ) {
      data["cliente_oculto"] = this.cliente_oculto;
      this.title = "";
      this.icone_title = "people_outline";
    }

    if (
      this.id_load != null &&
      this.id_load != undefined &&
      this.id_load != ""
    ) {
      service
        .getViewCompleta(this.id_load, "id", "asc")
        .then(function(response) {
          self.form = response.data;

          self.loading = false;
          self.disableButton = false;
        });
    } else {
      this.loading = false;
      this.disableButton = false;
    }

    this.$store.dispatch("setButtonBack", {
      in_form: true,
      rota: "inspecao",
      exibe: this.show_back_button,
      onBack: this.onBack
    });
    //this.$store.dispatch("user/save", this.tmpUser)
  },
  methods: {
    onCloseModal() {
      this.show_grafico = false;
    },
    onGrafico(item, tipo) {
      this.show_grafico = true;
    },
    mostra_nota(nota) {
      if (nota == null) return "N/C";

      if (nota == 0) return "N/C";

      if (nota == -1) return "N/A";

      return "C";
    },

    getClassNota(nota) {
      if (nota == null || nota == undefined) {
        return "null";
      }

      if (parseInt(nota) == -1) {
        return "null";
      }

      if (parseInt(nota) >= 0 && parseInt(nota) <= 8) {
        return "low";
      }

      if (parseInt(nota) > 8) {
        return "";
      }

      return "null";
    },

    getStyleNotaTotal(nota) {
      if (nota == null || nota == undefined) {
        return "";
      }

      if (parseFloat(nota) == -1) {
        return "";
      }

      if (parseFloat(nota) >= 0 && parseFloat(nota) <= 8) {
        return "color: #f44336;";
      }

      if (parseFloat(nota) > 8) {
        return "color: #2196f3";
      }

      return "";
    },

    botao_voltar() {
      var self = this;

      if (this.onBack != null && this.onBack != undefined) {
        this.onBack(self);
      }
    },
    changed(prop) {},

    configureMessages() {
      const dict = {
        // email: {
        //   required: 'O e-mail não pode ser vazio!',
        //   email: 'É necessário informar um e-mail válido!'
        // },
        nome: {
          required: "Nome não pode ser vazio!"
        }
        // cnpj: {
        //   required: 'CPF/CNPJ não pode ser vazio!',
        // cpf: true //testará o método de CPF
        // }
      };

      this.setFieldsValidator(dict);

      //this.p_validator.localize('en', dict);
    },
    onPreSaveContatos() {
      this.show_sub_form = false;
    },
    onPosSaveContatos(itens) {
      this.show_sub_form = true;
    },
    salvar() {
      var self = this;

      if (!this.validar()) return false;

      self.msg_status = "Salvando..";
      self.loading = true;
      self.data = Util.dateToBd(self.data);
      self.data_cadastro = Util.dateToBd(self.data_cadastro);

      service
        .salvar(this.form)
        .then(function(response) {
          var retorno = response.data;

          self.show_message = "on";
          self.message_text = "inspecao salvo com sucesso!";

          self.interval_message = setInterval(self.clear_message, 6000);

          var item = retorno.item;

          self.msg_status = "Carregando..";
          self.loading = false;

          self.form = item;

          if (self.onSave != null && self.onSave != undefined) {
            self.onSave(retorno, "save");
          }
        })
        .catch(function(error) {});
    },

    excluir() {
      let self = this;
      self.msg_status = "Excluindo..";
      self.loading = true;

      var fn_return = function(response) {
        var retorno = response.data;
        if (self.onSave != null && self.onSave != undefined) {
          self.onSave(retorno, "delete");
        }
        self.msg_status = "Carregando..";
        self.loading = false;
        self.botao_voltar();
      };
      if (this.form.id == null) return false;

      service.delete(this.form.id).then(fn_return);
      //	obj_api.call_delete("cliente", this.id, fn_return);
    },
    clear_message() {
      this.show_message = "off";
      clearInterval(this.interval_message);
    },
    hideModal() {
      this.showDialogError = false;
    },
    validar() {
      this.indicateAllErrors(); //Verifica todos os possíveis erros em tela.
      console.log("erros? ");
      console.log(this.p_validator.errors);

      if (this.p_validator.errors.length > 0) {
        this.showDialogError = true;
        return false;
      }

      return true;
    }
  }
};
</script>